import {AfterViewInit, Component, Input, OnChanges, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Constants} from '../../constants';
import {SessionService} from '../../../../services/session.service';
import { FormsUtils } from '../../../../utils/FormUtils';

declare var hbspt: any;

@Component({
    selector: 'app-form-company-template',
    templateUrl: './form-company-template.component.html',
    styleUrls: ['./form-company-template.component.scss']
})
export class FormCompanyTemplateComponent implements AfterViewInit, OnInit {
    @Input() type: number;
    form: FormGroup;
    isAnual: boolean;
    isIntegration: boolean;
    isPlanmensual:boolean;
    isPlananual:boolean;
    isPlanmensualEmpresa:boolean;
    idForm: string;

    constructor(
        private fb: FormBuilder,
        private sessionService: SessionService,
        private _formsUtils: FormsUtils
    ) {
    }
    ngAfterViewInit(): void {
        if (this.type) {
            this.isAnual = this.type === Constants.typeCompanyAnual ? true : false;
            this.isIntegration = this.type === Constants.typeCompanyIntegration ? true : false;
            this.isPlanmensual = this.type === Constants.planMensual ? true : false;
            this.isPlananual = this.type === Constants.planAnual ? true : false;
            this.isPlanmensualEmpresa = this.type === Constants.planMensualEmpresa ? true : false;

            if (this.isAnual) {
                if (this.sessionService.getCountryData()) {
                    hbspt.forms.create({
                        portalId: '5707307',
                        formId: '1b8be10a-0c96-4b40-a07c-98990cee804b',
                        target: '#form-company-container'
                    });
                } else {
                    hbspt.forms.create({
                        portalId: '5707307',
                        formId: '98f3a916-0fdf-4b25-a641-dc0b7a12d244',
                        target: '#form-company-container'
                    });
                }
            } else if (this.isPlanmensual) {
                hbspt.forms.create({
                    portalId: "5707307",
                    formId: "606784f1-c375-4f7f-a894-5c930c205b92",
                    target: '#form-company-container'
                });
            }
            else if (this.isPlanmensualEmpresa) {
                hbspt.forms.create({
                    portalId: "5707307",
                    formId: "dcf20dc6-209b-4022-b441-5796e526fe6a",                
                    target: '#form-company-container'
                });
            }
             else if (this.isPlananual) {
                hbspt.forms.create({
                    portalId: "5707307",
                    formId: "c0fae10f-934d-4290-85a3-bc1516f5ec7a",
                    target: '#form-company-container'
                });
            }
             else if (this.isIntegration) {
                hbspt.forms.create({
                    portalId: '5707307',
                    formId: '0e01eec6-507e-462b-9ed5-36c183fb632a',
                    target: '#form-company-container'
                });
            } else {
                hbspt.forms.create({
                    portalId: '5707307',
                    formId: '66537e48-72f0-4b53-8b21-1c0646fbfd8e',
                    target: '#form-company-container'
                });
            }
        }
    }

    initForm(): void {
        switch (this.type) {
            case Constants.typeCompanyMonth:
                this.form = this.fb.group({
                    name: ['', Validators.compose([Validators.required])],
                    lastName: ['', Validators.compose([Validators.required])],
                    email: ['', Validators.compose([Validators.required])],
                    phone: ['', Validators.compose([Validators.required])],
                    company: ['', Validators.compose([Validators.required])],
                    sector: ['', Validators.compose([Validators.required])],
                    transactionsPerComplement: ['', Validators.compose([Validators.required])],
                    video: [false, Validators.compose([Validators.required])],
                    sms: [false, Validators.compose([Validators.required])],
                    usaConstancy: [false, Validators.compose([Validators.required])],
                    etheriumConstancy: [false, Validators.compose([Validators.required])],
                    mexicoConstancy: [false, Validators.compose([Validators.required])],
                    ineValidation: [false, Validators.compose([Validators.required])],
                    inePhoto: [false, Validators.compose([Validators.required])],
                    signComparison: [false, Validators.compose([Validators.required])],
                    videoConstancy: [false, Validators.compose([Validators.required])],
                    videoSignConstancy: [false, Validators.compose([Validators.required])],
                });
                break;
            case Constants.typeCompanyAnual:
                this.form = this.fb.group({
                    name: ['', Validators.compose([Validators.required])],
                    lastName: ['', Validators.compose([Validators.required])],
                    email: ['', Validators.compose([Validators.required])],
                    phone: ['', Validators.compose([Validators.required])],
                    company: ['', Validators.compose([Validators.required])],
                    sector: ['', Validators.compose([Validators.required])],
                    transactionsPerComplement: ['', Validators.compose([Validators.required])],
                    video: [false, Validators.compose([Validators.required])],
                    sms: [false, Validators.compose([Validators.required])],
                    usaConstancy: [false, Validators.compose([Validators.required])],
                    etheriumConstancy: [false, Validators.compose([Validators.required])],
                    mexicoConstancy: [false, Validators.compose([Validators.required])],
                    ineValidation: [false, Validators.compose([Validators.required])],
                    inePhoto: [false, Validators.compose([Validators.required])],
                    signComparison: [false, Validators.compose([Validators.required])],
                    videoConstancy: [false, Validators.compose([Validators.required])],
                    videoSignConstancy: [false, Validators.compose([Validators.required])],
                });
                break;
            case Constants.typeCompanyIntegration:
                this.form = this.fb.group({
                    name: ['', Validators.compose([Validators.required])],
                    lastName: ['', Validators.compose([Validators.required])],
                    email: ['', Validators.compose([Validators.required])],
                    phone: ['', Validators.compose([Validators.required])],
                    company: ['', Validators.compose([Validators.required])],
                    sector: ['', Validators.compose([Validators.required])]
                });
                break;
        }
    }

    ngOnInit(): void {
        this.idForm = this._formsUtils.getFormIdByLang();
        this._formsUtils.buildSovosForm();
    }

}
